import { addDays } from "date-fns";
import type { EntregaDoPedido } from "@bookdental/schemas";
import type { PedidoDaEtiqueta, Remetente, ServicoDaEtiqueta } from "@/components/production/etiquetas";

/** Dados de mentira pra prévia e pra "Imprimir teste" — nenhum pedido de verdade é tocado. */
export const PEDIDO_EXEMPLO: PedidoDaEtiqueta = {
  id: "exemplo",
  numero: 1042,
  paciente: "Maria da Silva Pereira",
  dentista: "Dr. João Souza",
  clinica: "Clínica Sorriso",
  prazo: addDays(new Date(), 5),
  criadoEm: new Date(),
};

export const SERVICOS_EXEMPLO: ServicoDaEtiqueta[] = [
  {
    ordem: 1,
    servico: "Coroa de zircônia",
    material: "Zircônia multicamada",
    dentes: "11, 21",
    cor: "A2",
    observacao: "Atenção ao ponto de contato",
    etapa: "Fresagem",
    tecnico: "Carlos",
  },
  { ordem: 2, servico: "Faceta cerâmica", material: "Dissilicato de lítio", dentes: "12", cor: "A1", etapa: "Maquiagem", tecnico: "Ana" },
];

export const DESTINO_EXEMPLO: EntregaDoPedido = {
  destinatario: "Clínica Sorriso",
  telefone: "(11) 98765-4321",
  cep: "01310100",
  endereco: "Avenida Paulista",
  numero: "1000",
  complemento: "Sala 12",
  bairro: "Bela Vista",
  cidade: "São Paulo",
  uf: "SP",
};

export const REMETENTE_EXEMPLO = (nome: string): Remetente => ({ nome, cidade: "São Paulo", uf: "SP", telefone: "(11) 3333-4444" });
